import styled from 'styled-components';

const Box = styled.div``;

export default Box;
